import React from "react";

// Common Button Style
const buttonStyle = (bgColor, borderColor, textColor) => ({
  backgroundColor: bgColor,
  border: `1px solid ${borderColor}`,
  color: textColor,
});

// Individual Buttons
const EditButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-indigo-700 rounded-lg text-indigo-700 hover:text-indigo-800 hover:border-indigo-800 hover:shadow-lg"
  >
    Edit
  </button>
);

const DeleteButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-red-700 rounded-lg text-red-700 hover:text-red-800 hover:border-red-800 hover:shadow-lg"
  >
    Delete
  </button>
);

const SaveButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-green-700 rounded-lg text-green-700 hover:text-green-800 hover:border-green-800 hover:shadow-lg"
  >
    Save
  </button>
);

const CancelButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-orange-700 rounded-lg text-orange-700 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg"
  >
    Cancel
  </button>
);

const CreateButton = ({ onClick, name }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1 cursor-pointer tracking-[.1em] uppercase border border-blue-700 rounded-lg text-blue-700 hover:text-blue-800 hover:border-blue-800 hover:shadow-lg"
  >
    Create {name && name}
  </button>
);

const AddButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-emerald-700 rounded-lg text-emerald-700 hover:text-emerald-800 hover:border-emerald-800 hover:shadow-lg"
  >
    Add
  </button>
);

// Export All Buttons
export {
  EditButton,
  DeleteButton,
  SaveButton,
  CancelButton,
  CreateButton,
  AddButton,
};
